import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import Custom from './custom'

// Panel-owned data - reset by resetPanelState when the citizen enters a different
// panel. Common-service data (commonObj / commonObjCommonConfig) is never reset.
const defaultAgriResearchCommonObj = () => ({
  hasDropdownLoaded: false,
  seedNameList: [],
  seedTypeNameList: [],
  seedVarietyList: [],
  seedClassList: [],
  publicationTypeList: [],
  publicationTitleList: [],
  publicationFeeList: [],
  qualityUnitList: [],
  productionSeasonList: [],
  seedPacketList: [],
  serviceList: [],
  projectList: [],
  subProjectList: [],
  sectorList: [],
  researchDivisionList: [],
  publicationContentAreaList: [],
  researchTypeList: Custom.researchTypeList,
  circularList: [],
  thematicAreaList: [],
  subSectorList: [],
  activityStatusList: Custom.activityStatusList,
  orgTypeList: Custom.orgTypeList,
  budgetHeadList: [],
  budgetTypeList: [],
  componentOrgList: [],
  feePolicy: [],
  organizationType: Custom.organizationType,
  divisionalResearchList: [],
  publicationFeeTypeList: Custom.publicationFeeTypeList,
  schemeList: [],
  seedProducersList: [],
  seedProcessingCentersList: [],
  monitoringTeamList: [],
  roleInformationList: []
})

// Full default state - restored by resetExternalState on admin/office login
const defaultState = () => ({
    activePanel: null,
    agriResearchCommonObj: defaultAgriResearchCommonObj(),
    commonObjCommonConfig: {
      hasDropdownLoaded: false,
      bankList: [],
      branchList: []
    }
})

const state = defaultState()

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations: Object.assign({}, mutations, {
    resetPanelState (state) {
      state.agriResearchCommonObj = defaultAgriResearchCommonObj()
    },
    resetExternalState (state) {
      Object.assign(state, defaultState())
    }
  })
}
